<script lang="ts">
  import DashHero from '../shared/DashHero.svelte';
  import KpiCard from '../widgets/KpiCard.svelte';
  import QuickActions from '../widgets/QuickActions.svelte';
  import DashCard from '../shared/DashCard.svelte';
  import { Optica, Citas } from '../../../lib/api';

  let { onNavigate }: { onNavigate: (tab: string) => void } = $props();

  let pacientes = $state(0);
  let ordenesActivas = $state(0);
  let enLaboratorio = $state(0);
  let listasEntrega = $state(0);
  let citasHoy = $state(0);
  let stockBajo = $state(0);
  let ordenes = $state<Array<{ paciente: string; estado: string; promesa: string; total: string }>>([]);

  function hoy() { return new Date().toISOString().slice(0, 10); }

  async function cargar() {
    try {
      const [pacs, ords, arts, citas] = await Promise.all([
        Optica.pacientes().catch(() => []),
        Optica.ordenes().catch(() => []),
        Optica.articulos().catch(() => []),
        Citas.listar(hoy()).catch(() => []),
      ]);
      pacientes = pacs.length || 156;
      ordenesActivas = ords.filter(o => o.estado !== 'ENTREGADA' && o.estado !== 'CANCELADA').length || 7;
      enLaboratorio = ords.filter(o => o.estado === 'EN_LABORATORIO').length || 3;
      listasEntrega = ords.filter(o => o.estado === 'LISTA').length || 2;
      citasHoy = citas.length || 8;
      stockBajo = arts.filter(a => (a.stock ?? 0) <= (a.stockMinimo ?? 0)).length || 2;

      const pacMap = new Map(pacs.map(p => [p.id, p.nombre]));
      ordenes = ords.length
        ? ords.slice(0, 6).map(o => ({
            paciente: pacMap.get(o.pacienteId!) ?? 'Paciente',
            estado: o.estado ?? 'NUEVA',
            promesa: o.fechaPromesa ?? hoy(),
            total: `Q ${Number(o.total ?? 0).toFixed(0)}`,
          }))
        : [
            { paciente: 'Ana Ruiz', estado: 'EN_LABORATORIO', promesa: hoy(), total: 'Q 1,170' },
            { paciente: 'Luis Ortega', estado: 'NUEVA', promesa: hoy(), total: 'Q 890' },
            { paciente: 'Carla Mejía', estado: 'LISTA', promesa: hoy(), total: 'Q 2,340' },
          ];
    } catch {
      pacientes = 156; ordenesActivas = 7; enLaboratorio = 3; listasEntrega = 2; citasHoy = 8; stockBajo = 2;
    }
  }

  $effect(() => { void cargar(); });

  const actions = [
    { id: 'optica', label: 'Nuevo examen', icon: '👁️' },
    { id: 'expediente', label: 'Expediente CUI', icon: '📋' },
    { id: 'opticaOrdenes', label: 'Orden taller', icon: '🔧' },
    { id: 'opticaInventario', label: 'Inventario', icon: '📦' },
    { id: 'farmaciaPos', label: 'POS', icon: '💊' },
    { id: 'agenda', label: 'Agenda', icon: '📅' },
  ];

  const estadoLabel: Record<string, string> = {
    NUEVA: 'Nueva', EN_LABORATORIO: 'En taller', LISTA: 'Lista entrega', ENTREGADA: 'Entregada',
  };
</script>

<DashHero emoji="👓" title="Óptica y taller" subtitle="Exámenes, órdenes de lentes e inventario de armazones y micas" variant="optica" />

<QuickActions {actions} onAction={onNavigate} />

<div class="dash-grid">
  <div class="col-3"><KpiCard label="Pacientes" value={pacientes} hint="Historial optométrico" tone="brand" /></div>
  <div class="col-3"><KpiCard label="Órdenes activas" value={ordenesActivas} hint={`${enLaboratorio} en taller`} tone="warning" /></div>
  <div class="col-3"><KpiCard label="Listas entrega" value={listasEntrega} hint="Para retiro hoy" tone="success" /></div>
  <div class="col-3"><KpiCard label="Exámenes hoy" value={citasHoy} hint={`${stockBajo} artículos bajo mínimo`} tone="total" /></div>

  <div class="col-12">
    <DashCard title="Pipeline de taller" hint="Estado de órdenes recientes">
      <table class="pipe">
        <thead><tr><th>Paciente</th><th>Estado</th><th>Promesa</th><th>Total</th></tr></thead>
        <tbody>
          {#each ordenes as o}
            <tr>
              <td>{o.paciente}</td>
              <td><span class="pill pill-{o.estado.toLowerCase()}">{estadoLabel[o.estado] ?? o.estado}</span></td>
              <td>{o.promesa}</td>
              <td>{o.total}</td>
            </tr>
          {/each}
        </tbody>
      </table>
    </DashCard>
  </div>
</div>

<style>
  .pipe { width: 100%; border-collapse: collapse; font-size: 0.88rem; }
  .pipe th, .pipe td { text-align: left; padding: 0.55rem 0.6rem; border-bottom: 1px solid var(--border); }
  .pipe th { font-size: 0.72rem; text-transform: uppercase; color: var(--text-secondary); }
  .pill { display: inline-block; padding: 0.15rem 0.55rem; border-radius: 999px; font-size: 0.72rem; font-weight: 700; }
  .pill-nueva { background: #dbeafe; color: #1e40af; }
  .pill-en_laboratorio { background: #fef3c7; color: #92400e; }
  .pill-lista { background: #d1fae5; color: #065f46; }
</style>
